export enum PLAYER_MODE {
    PUBLISHER = 'PUBLISHER',
    VIEWER = 'VIEWER'
}

export enum PLAYER_DISPLAY_MODE {
    DEFAULT, EMBEDDED
}
